<template>
    <div class="card-page">
        <div class="card">
            <div class="card-body">

                <div v-if="step === 'template'">
                    <div class="h3 mb-4">Välj mall:</div>
                    <div v-for="t in templates" :key="t.id" class="my-1">
                        <a @click="select(t)" class="" v-if="enabledTemplates.includes(t.type)">
                            <TemplateSelection :title="t.Title" :description="t.Description" :icon="t.Icon" class="mt-2" />
                        </a>
                    </div>
                </div>

                <div v-if="step === 'content'">
                    <div class="h3 mb-4" ref="xx">Skapa innehåll</div>

                    <CreateDocumentCompany v-if="selectedTemplate.type==='company'" v-on:prev="prev()"/>
                    <CreateDocumentCompetitors v-if="selectedTemplate.type==='competitors'" v-on:prev="prev()"/>
                    <CreateDocumentValuation v-if="selectedTemplate.type==='valuation'" v-on:prev="prev()"/>
                    <CreateDocumentClosingMeeting v-if="selectedTemplate.type==='closingmeeting'" v-on:prev="prev()"/>
                    <CreateDocumentPreClosingMeeting v-if="selectedTemplate.type==='preclosingmeeting'" v-on:prev="prev()"/>
                    <CreateDocumentFutureMeeting v-if="selectedTemplate.type==='futuremeeting'" v-on:prev="prev()"/>
                    <CreateDocumentYearEndMeeting v-if="selectedTemplate.type==='yearendmeeting'" v-on:prev="prev()"/>
                    <CreateDocumentYearReview v-if="selectedTemplate.type==='yearreview'" v-on:prev="prev()"/>

                </div>

            </div>
        </div>
    </div>

</template>

<script>
/* tslint:disable */

    import TemplateSelection from "@/views/TemplateSelection";
    import CreateDocumentValuation from "@/views/CreateDocumentValuation";
    import CreateDocumentCompany from "@/views/CreateDocumentCompany";
    import CreateDocumentCompetitors from "@/views/CreateDocumentCompetitors";
    import CreateDocumentClosingMeeting from "@/views/CreateDocumentClosingMeeting";
    import CreateDocumentYearEndMeeting from "@/views/CreateDocumentYearEndMeeting";
    import CreateDocumentPreClosingMeeting from "@/views/CreateDocumentPreClosingMeeting";
    import CreateDocumentFutureMeeting from "@/views/CreateDocumentFutureMeeting";
    import CreateDocumentYearReview from "@/views/CreateDocumentYearReview";
    import {templates} from '@/config';
import user from "@/store/modules/user";

    export default {
        name: "CreateDocument",
        components: {CreateDocumentClosingMeeting, CreateDocumentCompetitors, CreateDocumentCompany, CreateDocumentValuation, TemplateSelection, CreateDocumentPreClosingMeeting, CreateDocumentFutureMeeting, CreateDocumentYearEndMeeting, CreateDocumentYearReview},
        data () {
            return {
                step: 'template',
                selectedBranch: undefined,
                documentTitle: undefined,
                selectedTemplate: {id:0},
                templates: [
                    {
                        id: 1,
                        type: 'company',
                        Title: "Bolagsanalys",
                        Description: "En bolagsanalys baserad på historisk data från bolagets fem senaste bokslut.",
                        Icon: 'aim'
                    },
                    {
                        id: 2,
                        type: 'competitors',
                        Title: "Konkurrentjämförelse",
                        Description: "En konkurrentjämförelse baserad på historisk data från bolagets fem senaste bokslut.",
                        Icon: 'compare'
                    },
                    {
                        id: 3,
                        type: 'valuation',
                        Title: "Förenklad kassaflödesvärdering",
                        Description: "En kassaflödesvärdering baserad på historisk data från bolagets fem senaste bokslut.",
                        Icon: 'trophy2'
                    },
                    {
                        id: 4,
                        type: 'closingmeeting',
                        Title: "Bokslutsmöte",
                        Description: "Bokslutsmötet är främst tänkt att användas av Ekonomiservice i samband med att bokslutsarbetet avslutas (för Revision rekommenderas det snarlika dokumentet Årsavslutsmöte). Som underlag används en importerad SIE-fil som följer BAS-kontoplanen.",
                        Icon: 'calendar-31'
                    },
                    {
                        id: 5,
                        type: 'preclosingmeeting',
                        Title: "Inför Bokslut",
                        Description: "Inför bokslut kan användas av såväl Ekonomiservice som Revision i samband med årsavslutet och fokus ligger på vilka åtgärder kunden bör göra innan årsavslut. Som underlag används en importerad SIE-fil som följer BAS-kontoplanen.",
                        Icon: 'hourglass'
                    },
                    {
                        id: 6,
                        type: 'futuremeeting',
                        Title: "Framtidsmöte",
                        Description: "Framtidsmötet är tänkt att kunna användas av såväl Ekonomiservice, Revision samt Certifierade Affärsrådgivare i samband med framtidsriktad rådgivning. Som underlag används en importerad SIE-fil som följer BAS-kontoplanen eller senaste officiella bokslut.",
                        Icon: 'binoculars2'
                    },
                    {
                        id: 7,
                        type: 'yearendmeeting',
                        Title: "Årsavslutsmöte",
                        Description: "Årsavslutsmötet är främst tänkt att användas av Revision i samband med att revisionsarbetet avslutas (för Ekonomiservice rekommenderas det snarlika dokumentet Bokslutsmöte). Som underlag används en importerad SIE-fil som följer BAS-kontoplanen.",
                        Icon: 'calendar-31'
                    },
                    {
                        id: 8,
                        type: 'yearreview',
                        Title: "Årsgenomgång",
                        Description: "Årsgenomgången använder sig av inlästa SIE-filer som underlag för att snabbt och enkelt skapa en snygg presentation",
                        Icon: 'calendar-31'
                    },
                ]
            }
        },
        async mounted() {
            await user.setSelectedDocument(null);
            await user.setSelectedDocumentBlob(null);
        },
        methods: {
            select (template) {
                this.selectedTemplate = template;
                this.next();
            },
            prev () {
                this.step = 'template';
            },
            next () {
                if (this.selectedTemplate.id === 0) return;
                this.step = 'content';
            }
        },
        computed: {
            enabledTemplates() {
                return templates;
            }
        }
    }
</script>

<style scoped lang="scss">
    .item:hover {
        border-color: get('colors.Secondary');
    }
</style>

<style>
    .dropdown-toggle::after {
        display:none;
    }
</style>
